import * as React from "react";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from 'react-bootstrap/Card';

export default class extends React.Component {
  render() {
    return <>
      <Card>

        <Card.Body>
          <Row>
            <Col xs="auto">
              <Spinner animation="border" variant="info"/>
            </Col>
            <Col className="py-1">
              Loading quotation...
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  }
}